var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dl',_vm._l((_vm.tags),function(item){return _c('v-chip',{staticClass:"mr-1",attrs:{"tag":"dd","small":""}},[_vm._v(" "+_vm._s(item)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }